import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetPersonnes, apiUpdatePersonne } from "../../../api/ApiPersonnes";
import ComponentTitle from "../../layout/ComponentTitle";
import { useTranslation } from "react-i18next";

const ComponentFocusRencontre = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [personnes, setPersonnes] = useState([]);
  const [focusPrimaire, setFocusPrimaire] = useState("");
  const [focusSecondaire1, setFocusSecondaire1] = useState("");
  const [focusSecondaire2, setFocusSecondaire2] = useState("");
  const [focusSecondaire3, setFocusSecondaire3] = useState("");
  const [focusSecondaire4, setFocusSecondaire4] = useState("");

  const recupPersonnes = async () => {
    const res = await apiGetPersonnes(ReduxInstance._id);
    if (res) {
      setPersonnes(res.data);
      let indiceSecondaire = 1;
      res.data.forEach((item) => {
        if (item.focusPrimaire) {
          setFocusPrimaire(item._id);
        }
        if (item.focusSecondaire) {
          if (indiceSecondaire === 1) {
            setFocusSecondaire1(item._id);
          }
          if (indiceSecondaire === 2) {
            setFocusSecondaire2(item._id);
          }
          if (indiceSecondaire === 3) {
            setFocusSecondaire3(item._id);
          }
          if (indiceSecondaire === 4) {
            setFocusSecondaire4(item._id);
          }
          indiceSecondaire++;
        }
      });
    }
  };

  const saveFocus = async (personneID, type, indice = null) => {
    if (type === "focusPrimaire") {
      /* on enlève l'état du orgunit qui était déjà en focus  */
      if (focusPrimaire) {
        const myFormPrimaireRemove = new FormData();
        myFormPrimaireRemove.append("focusPrimaire", false);
        await apiUpdatePersonne(focusPrimaire, myFormPrimaireRemove);
      }

      /* On met à jour le nouveau focus */
      if (personneID) {
        const myFormPrimaireAdd = new FormData();
        myFormPrimaireAdd.append("focusPrimaire", true);
        await apiUpdatePersonne(personneID, myFormPrimaireAdd);
        setFocusPrimaire(personneID);
      } else {
        setFocusPrimaire("");
      }
    }

    if (type === "focusSecondaire") {
      /* focus secondaire 1 */
      if (indice === "focusSecondaire1") {
        if (focusSecondaire1) {
          const myFormSecondaireRemove1 = new FormData();
          myFormSecondaireRemove1.append("focusSecondaire", false);
          await apiUpdatePersonne(focusSecondaire1, myFormSecondaireRemove1);
        }
        if (personneID) {
          const myFormSecondaireAdd1 = new FormData();
          myFormSecondaireAdd1.append("focusSecondaire", true);
          await apiUpdatePersonne(personneID, myFormSecondaireAdd1);
          setFocusSecondaire1(personneID);
        } else {
          setFocusSecondaire1("");
        }
      }
      /* focus secondaire 2 */
      if (indice === "focusSecondaire2") {
        if (focusSecondaire2) {
          const myFormSecondaireRemove2 = new FormData();
          myFormSecondaireRemove2.append("focusSecondaire", false);
          await apiUpdatePersonne(focusSecondaire2, myFormSecondaireRemove2);
        }
        if (personneID) {
          const myFormSecondaireAdd2 = new FormData();
          myFormSecondaireAdd2.append("focusSecondaire", true);
          await apiUpdatePersonne(personneID, myFormSecondaireAdd2);
          setFocusSecondaire2(personneID);
        } else {
          setFocusSecondaire2("");
        }
      }
      /* focus secondaire 3 */
      if (indice === "focusSecondaire3") {
        if (focusSecondaire3) {
          const myFormSecondaireRemove3 = new FormData();
          myFormSecondaireRemove3.append("focusSecondaire", false);
          await apiUpdatePersonne(focusSecondaire3, myFormSecondaireRemove3);
        }
        if (personneID) {
          const myFormSecondaireAdd3 = new FormData();
          myFormSecondaireAdd3.append("focusSecondaire", true);
          await apiUpdatePersonne(personneID, myFormSecondaireAdd3);
          setFocusSecondaire3(personneID);
        } else {
          setFocusSecondaire3("");
        }
      }
      /* focus secondaire 4 */
      if (indice === "focusSecondaire4") {
        if (focusSecondaire4) {
          const myFormSecondaireRemove4 = new FormData();
          myFormSecondaireRemove4.append("focusSecondaire", false);
          await apiUpdatePersonne(focusSecondaire4, myFormSecondaireRemove4);
        }
        if (personneID) {
          const myFormSecondaireAdd4 = new FormData();
          myFormSecondaireAdd4.append("focusSecondaire", true);
          await apiUpdatePersonne(personneID, myFormSecondaireAdd4);
          setFocusSecondaire4(personneID);
        } else {
          setFocusSecondaire4("");
        }
      }
    }
  };

  useEffect(() => {
    recupPersonnes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentTitle title={t("admin.PageAdminAlaUne.blocRencontreTitre")} />
      <p>{t("admin.PageAdminAlaUne.blocRencontreText")}</p>
      <div className="d-flex flex-column flex-lg-row zoneFocus">
        <div className="m-1 p-3 zoneFocusPrimaire align-items-center d-flex">
          <Form.Select
            name="focusPrimaire"
            value={focusPrimaire}
            onChange={(e) => saveFocus(e.target.value, "focusPrimaire")}
          >
            <option value="">{t("commun.form.placeholder.choixCollaborateurPremierPlan")}</option>
            {personnes.map((item) => (
              <option value={item._id} key={item._id}>
                {item.prenom} {item.nom}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="d-flex flex-column constainerZoneFocusSecondaire">
          <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire1"
              value={focusSecondaire1}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire1")}
            >
              <option value="">{t("commun.form.placeholder.choixCollaborateurSecondPlan")}</option>
              {personnes.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.prenom} {item.nom}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire2"
              value={focusSecondaire2}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire2")}
            >
              <option value="">{t("commun.form.placeholder.choixCollaborateurSecondPlan")}</option>
              {personnes.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.prenom} {item.nom}
                </option>
              ))}
            </Form.Select>
          </div>
          {/* <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire3"
              value={focusSecondaire3}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire3")}
            >
              <option value="">{t("commun.form.placeholder.choixCollaborateurSecondPlan")}</option>
              {personnes.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.prenom} {item.nom}
                </option>
              ))}
            </Form.Select>
          </div> */}
          {/* <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire4"
              value={focusSecondaire4}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire4")}
            >
              <option value="">{t("commun.form.placeholder.choixCollaborateurSecondPlan")}</option>
              {personnes.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.prenom} {item.nom}
                </option>
              ))}
            </Form.Select>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ComponentFocusRencontre;
